import React, { useRef, useEffect, useState } from "react";
import { Link } from "gatsby";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Search from "./search/index"
import "./styles/navigation.scss";

const searchIndices = [{ name: `Pages`, title: `Pages` }]

const Navigation = () => {
  const [openMenu, toggleMenu] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [hState, sethState] = useState("top");
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    let isMounted = true;
    var lastVal = 0;
    window.onscroll = function () {
      let y = window.scrollY;
      if ((y > lastVal + 0 && isMounted) && (!searchOpen)) {
        sethState("down");
      }
      if ((y < lastVal - 10 && isMounted) && (!searchOpen)) {
        sethState("up");
      }
      if ((y === 0 && isMounted) && (!searchOpen)) {
        sethState("top");
      }
      lastVal = y;
    };
    window.addEventListener("scroll", () => {
      if ((isMounted) && (!searchOpen)) {
        setScroll(window.scrollY > 20);
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setSearchOpen(false)
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  return (
    <Navbar
      expand="xl"
      fixed="top"
      className={
        (scroll ? "scrolled" : "") +
        " " +
        (openMenu ? "open" : "") +
        " " +
        hState +
        " " +
        (searchOpen ? "search-open" : "")
      }
    >
      <Container fluid="xl">
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => toggleMenu(!openMenu)}
        />
        <Navbar.Brand href="/" className="d-inline-block">
          <img
            src="https://web-cdn.meridianuniversity.edu/logos/meridian-university-logo.svg"
            className="d-inline-block align-top nav-logo"
            alt="Meridian University Logo"
          />
        </Navbar.Brand>
        <Navbar.Collapse className="order-3 order-xl-2">
          <Nav className="mx-lg-auto main-nav" navbarScroll>
            <NavDropdown
              renderMenuOnMount={true}
              title="About"
              id="basic-nav-dropdown"
            >
              <Container fluid="lg">
                <Row className="px-2 px-xl-auto">
                  <Col md={3} className="pt-xl-5 pt-4">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/about/about-meridian/vision-and-mission"
                          className="navLink"
                        >
                          About Meridian
                        </Link>
                        <ul className="navLinkSubMenu">
                          <li>
                            <Link
                              to="/about/about-meridian/vision-and-mission"
                              className="navLink"
                            >
                              Vision and Mission
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about/about-meridian/accreditation"
                              className="navLink"
                            >
                              Accreditation
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about/about-meridian/diversity"
                              className="navLink"
                            >
                              Diversity
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about/about-meridian/faculty"
                              className="navLink"
                            >
                              Faculty
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about/about-meridian/executive-leadership"
                              className="navLink"
                            >
                              Executive Leadership
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                  <Col md={5} className="pt-xl-5 pt-4">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/about/about-meridian/locations-and-centers"
                          className="navLink"
                        >
                          Locations and Centers
                        </Link>
                        <ul className="navLinkSubMenu split-ul">
                          <li>
                            <Link
                              to="/about/about-meridian/locations-and-centers/san-francisco-bay-area-center"
                              className="navLink"
                            >
                              San Francisco Bay Area Center
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about/about-meridian/locations-and-centers/los-angeles-campus"
                              className="navLink"
                            >
                              Los Angeles Campus
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about/about-meridian/locations-and-centers/berlin-center"
                              className="navLink"
                            >
                              Berlin Center
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about/about-meridian/locations-and-centers/athens-center"
                              className="navLink"
                            >
                              Athens Center
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/about/about-meridian/locations-and-centers/johannesburg-center"
                              className="navLink"
                            >
                              Johannesburg Center
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                  <Col md={3} className="pt-xl-5 pt-4">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/about/center-for-transformative-learning/about-the-center"
                          className="navLink"
                        >
                          Center for Transformative Learning
                        </Link>
                        <ul className="navLinkSubMenu">
                          <li>
                            <Link
                              to="/about/center-for-transformative-learning/about-the-center"
                              className="navLink"
                            >
                              About the Center
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/public-programs/upcoming-programs-and-events/"
                              className="navLink"
                            >
                              Upcoming Programs
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                </Row>
                <hr />
                <Row className="secondary-menu pb-xl-5 pb-4 px-2 px-xl-auto">
                  <Col md={3}>
                    <ul>
                      <li className="navLinkHeader pb-4 pb-md-0">
                        <Link to="/about/video-center" className="navLink">
                          Video Center
                        </Link>
                      </li>
                    </ul>
                  </Col>
                  <Col md={3}>
                    <ul>
                      <li className="navLinkHeader pb-4 pb-md-0">
                        <Link
                          to="/about/university-chancellor-jean-houston"
                          className="navLink"
                        >
                          University Chancellor Jean Houston
                        </Link>
                      </li>
                    </ul>
                  </Col>
                  <Col md={3} className="text-md-center">
                    <ul>
                      <li className="navLinkHeader">
                        <a
                          href="https://careers.meridianuniversity.edu/"
                          className="navLink"
                        >
                          Careers
                        </a>
                      </li>
                      {/*<li className="navLinkHeader"><a href="https://scholarship.meridianuniversity.edu/" className="navLink">Institutional Repository</a></li>*/}
                    </ul>
                  </Col>
                  <Col md={3} className="text-md-center">
                    <ul>
                      <li className="navLinkHeader pb-4 pb-md-0">
                        <Link to="/about/contact-us" className="navLink">
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Container>
            </NavDropdown>
            <NavDropdown
              renderMenuOnMount={true}
              title="Admissions"
              id="basic-nav-dropdown"
            >
              <Container fluid="lg">
                <Row className="justify-content-lg-center">
                  <Col md={3} className="pt-xl-5 pt-4">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/admissions/graduate-admissions/admissions-overview"
                          className="navLink"
                        >
                          Graduate Admissions
                        </Link>
                        <ul className="navLinkSubMenu">
                          <li>
                            <Link
                              to="/admissions/graduate-admissions/admissions-overview"
                              className="navLink"
                            >
                              Admissions Overview
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/graduate-admissions/application-process"
                              className="navLink"
                            >
                              Application Process
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/graduate-admissions/info-sessions-and-events"
                              className="navLink"
                            >
                              Info Sessions &amp; Events
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/graduate-admissions/request-for-information"
                              className="navLink"
                            >
                              Request Information
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/graduate-admissions/apply-online"
                              className="navLink"
                            >
                              Apply Online
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/graduate-admissions/international-students"
                              className="navLink"
                            >
                              International Students
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/graduate-admissions/student-visas"
                              className="navLink"
                            >
                              Student Visas
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                  <Col md={3} className="pt-xl-5 pt-4">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/admissions/resources/alumni-and-students"
                          className="navLink"
                        >
                          Resources
                        </Link>
                        <ul className="navLinkSubMenu">
                          <li>
                            <Link
                              to="/admissions/resources/alumni-and-students"
                              className="navLink"
                            >
                              Student Stories and Experiences
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/resources/2024-25-academic-calendar"
                              className="navLink"
                            >
                              2024-25 Academic Calendar
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/resources/2025-26-academic-calendar"
                              className="navLink"
                            >
                              2025-26 Academic Calendar
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/resources/student-success"
                              className="navLink"
                            >
                              Student Success
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/resources/transcript-request"
                              className="navLink"
                            >
                              Transcript Request
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/resources/readmissions-application"
                              className="navLink"
                            >
                              Readmissions Application
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                  <Col md={6} className="pt-xl-5 pt-4">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/admissions/tuition-and-financial-aid/financial-aid-overview"
                          className="navLink"
                        >
                          Tuition and Financial Aid
                        </Link>
                        <ul className="navLinkSubMenu split-ul">
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/financial-aid-overview"
                              className="navLink"
                            >
                              Financial Aid Overview
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/impact-scholarships"
                              className="navLink"
                            >
                              Impact Scholarships
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/federal-student-aid-process"
                              className="navLink"
                            >
                              Federal Student Aid Process
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/financial-aid-for-international-students"
                              className="navLink"
                            >
                              Financial Aid for International Students
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/leave-withdrawals-and-refund-policy"
                              className="navLink"
                            >
                              Leave, Withdrawals and Refund Policy
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/doctoral-project-fees-and-financial-aid"
                              className="navLink"
                            >
                              Doctorial Project Fees and Financial Aid
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/cost-of-attendance"
                              className="navLink"
                            >
                              Cost of Attendance
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/student-accounts"
                              className="navLink"
                            >
                              Student Accounts
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/satisfactory-academic-progress"
                              className="navLink"
                            >
                              Satisfactory Academic Progress
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/veterans-educational-benefits"
                              className="navLink"
                            >
                              Veterans Educational Benefits
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/financial-aid-faqs"
                              className="navLink"
                            >
                              Financial Aid FAQs
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/admissions/tuition-and-financial-aid/glossary-of-financial-aid-terms"
                              className="navLink"
                            >
                              Glossary of Financial Aid Terms
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                </Row>
                <hr />
                <Row className="secondary-menu">
                  <Col lg={4} className="pb-lg-5 pb-4">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/admissions/consumer-information"
                          className="navLink"
                        >
                          Consumer Information
                        </Link>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Container>
            </NavDropdown>
            <NavDropdown
              renderMenuOnMount={true}
              title="Academics"
              id="basic-nav-dropdown"
            >
              <Container fluid="lg">
                <Row className="secondary-menu pt-lg-4 d-none d-xl-flex justify-content-xl-around">
                  <Col xl={3} className="text-center">
                    <ul>
                      <li className="navLinkHeader pb-4 pb-md-0">
                        <Link
                          to="/academics/degree-programs-overview"
                          className="navLink"
                        >
                          Degree Programs Overview
                        </Link>
                      </li>
                    </ul>
                  </Col>
                  <Col xl={3} className="text-center">
                    <ul>
                      <li className="navLinkHeader pb-4 pb-md-0">
                        <Link
                          to="/academics/academic-structure"
                          className="navLink"
                        >
                          Academic Structure
                        </Link>
                      </li>
                    </ul>
                  </Col>
                  <Col xl={3} className="text-center">
                    <ul>
                      <li className="navLinkHeader pb-4 pb-md-0">
                        <Link
                          to="/academics/professional-specialty-program-pathways"
                          className="navLink"
                        >
                          Professional Specialty Program Pathways
                        </Link>
                      </li>
                    </ul>
                  </Col>
                  <Col xl={3} className="text-center">
                    <ul>
                      <li className="navLinkHeader">
                        <Link to="/content/" className="navLink">
                          Content Resources
                        </Link>
                      </li>
                    </ul>
                  </Col>
                </Row>
                <hr className="d-none d-xl-block" />
                <Row className="justify-content-lg-between">
                  <Col xl={4} md={8} className="py-4 pt-xl-0">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/academics/concentrations"
                          className="navLink"
                        >
                          Concentrations
                        </Link>
                        <ul className="navLinkSubMenu split-ul">
                          <li>
                            <Link
                              to="/academics/concentrations/business-psychology"
                              className="navLink"
                            >
                              Business Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/clinical-psychology"
                              className="navLink"
                            >
                              Clinical Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/collective-trauma-and-social-healing"
                              className="navLink"
                            >
                              Collective Trauma and Social Healing
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/complexity-management"
                              className="navLink"
                            >
                              Complexity Management
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/depth-psychology"
                              className="navLink"
                            >
                              Depth Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/developmental-coaching"
                              className="navLink"
                            >
                              Developmental Coaching
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/expressive-and-movement-arts"
                              className="navLink"
                            >
                              Expressive and Movement Arts
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/generative-entrepreneurship"
                              className="navLink"
                            >
                              Generative Entrepreneurship
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/health-and-wellbeing-coaching"
                              className="navLink"
                            >
                              Health and Wellbeing Coaching
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/integral-psychology"
                              className="navLink"
                            >
                              Integral Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/organizational-development"
                              className="navLink"
                            >
                              Organizational Development
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/somatic-psychology"
                              className="navLink"
                            >
                              Somatic Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/transformative-leadership"
                              className="navLink"
                            >
                              Transformative Leadership
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/transformative-learning"
                              className="navLink"
                            >
                              Transformative Learning
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/transpersonal-psychology"
                              className="navLink"
                            >
                              Transpersonal Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/concentrations/yoga-and-psychology"
                              className="navLink"
                            >
                              Yoga and Psychology
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                  <Col xl={2} md={4} className="py-4 pt-xl-0">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/academics/business/graduate-school-of-business"
                          className="navLink"
                        >
                          Graduate School of Business
                        </Link>
                        <ul className="navLinkSubMenu">
                          <li>
                            <Link
                              to="/academics/business/graduate-school-of-business"
                              className="navLink"
                            >
                              Business Overview
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/business/mba-in-creative-enterprise"
                              className="navLink"
                            >
                              MBA in Creative Enterprise
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/business/business-faculty"
                              className="navLink"
                            >
                              Business Faculty
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/business/business-course-descriptions"
                              className="navLink"
                            >
                              Business Course Descriptions
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/business/concentrations"
                              className="navLink"
                            >
                              Concentrations
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                  <Col xl={2} md={4} className="py-4 pt-xl-0">
                    <ul>
                      <li className="navLinkHeader">
                        <Link
                          to="/academics/education/graduate-school-of-education"
                          className="navLink"
                        >
                          Graduate School of Education
                        </Link>
                        <ul className="navLinkSubMenu">
                          <li>
                            <Link
                              to="/academics/education/graduate-school-of-education"
                              className="navLink"
                            >
                              Education Overview
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/education/med-in-educational-leadership"
                              className="navLink"
                            >
                              MEd in Educational Leadership
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/education/edd-in-organizational-leadership"
                              className="navLink"
                            >
                              EdD in Organizational Leadership
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/education/education-course-descriptions"
                              className="navLink"
                            >
                              Education Course Descriptions
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/education/education-faculty"
                              className="navLink"
                            >
                              Education Faculty
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/education/concentrations"
                              className="navLink"
                            >
                              Concentrations
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                  <Col xl={2} md={4} className="py-4 pt-xl-0">
                    <ul className="mb-0 mb-xl-3">
                      <li className="navLinkHeader">
                        <Link
                          to="/academics/psychology/graduate-school-of-psychology"
                          className="navLink"
                        >
                          Graduate School of Psychology
                        </Link>
                        <ul className="navLinkSubMenu mb-0 mb-xl-3">
                          <li>
                            <Link
                              to="/academics/psychology/graduate-school-of-psychology"
                              className="navLink"
                            >
                              Psychology Overview
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/psychology/ma-in-psychology"
                              className="navLink"
                            >
                              MA in Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/psychology/ma-in-counseling-psychology"
                              className="navLink"
                            >
                              MA in Counseling Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/psychology/psyd-in-clinical-psychology"
                              className="navLink"
                            >
                              PsyD in Clinical Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/psychology/phd-in-psychology"
                              className="navLink"
                            >
                              PhD in Psychology
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/psychology/psychology-course-descriptions"
                              className="navLink"
                            >
                              Psychology Course Descriptions
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/psychology/psychology-faculty"
                              className="navLink"
                            >
                              Psychology Faculty
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/psychology/concentrations"
                              className="navLink"
                            >
                              Concentrations
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                  <hr className="d-md-none" />
                  <Col xl={2} md={4} className="pt-md-4 pt-0 d-xl-none">
                    <ul>
                      <li className="navLinkHeader pt-md-1">
                        <ul className="mb-0 mb-xl-3 mt-3 navLinkSubMenu">
                          <li>
                            <Link
                              to="/academics/degree-programs-overview"
                              className="navLink"
                            >
                              Degree Programs Overview
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/academic-structure"
                              className="navLink"
                            >
                              Academic Structure
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/academics/professional-specialty-programs"
                              className="navLink"
                            >
                              Professional Specialty Programs
                            </Link>
                          </li>
                          <li>
                            <Link to="/content/" className="navLink">
                              Content Resources
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Container>
            </NavDropdown>
            <NavDropdown
              renderMenuOnMount={true}
              title="Public Programs"
              id="basic-nav-dropdown"
              className="public-programs"
            >
              <Container fluid="lg">
                <Row className="justify-content-lg-center">
                  <Col
                    xxl={2}
                    xl={3}
                    xs={12}
                    className="py-xl-5 pt-4 text-lg-center"
                  >
                    <Link to="/public-programs/upcoming-programs-and-events">
                      Programs and Events
                    </Link>
                  </Col>
                  <Col
                    xxl={2}
                    xl={3}
                    xs={12}
                    className="py-xl-5 pt-4 text-lg-center"
                  >
                    <Link to="/public-programs/podcasts/integral-voices">
                      Podcasts
                    </Link>
                  </Col>
                  <Col
                    xxl={2}
                    xl={3}
                    xs={12}
                    className="py-xl-5 pt-4 text-lg-center"
                  >
                    <Link to="/public-programs/transformative-learning-labs">
                      Transformative Learning Labs
                    </Link>
                  </Col>
                </Row>
              </Container>
            </NavDropdown>
            <div className="dropdown">
              <Nav.Link
                href="/admissions/graduate-admissions/request-for-information"
                id="basic-nav-dropdown"
              >
                Get Info
              </Nav.Link>
            </div>
            <Nav.Link
              href="/admissions/graduate-admissions/apply-online"
              className="btn btn-primary m-4 d-md-none"
            >
              Apply
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <div className="d-flex flex-row order-2 order-xl-3">
          <Nav className="flex-row end">
            <NavDropdown
                renderMenuOnMount={true}
                title={
                  <svg width="22" height="22" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.43753 14.8438C9.08805 14.8441 10.6835 14.25 11.9319 13.1704L15.1725 16.411C15.2165 16.4729 15.2733 16.5247 15.3391 16.5628C15.4048 16.601 15.4779 16.6245 15.5536 16.632C15.6292 16.6394 15.7055 16.6305 15.7774 16.606C15.8493 16.5814 15.9151 16.5417 15.9703 16.4895C16.0256 16.4373 16.069 16.3739 16.0976 16.3035C16.1263 16.2332 16.1395 16.1574 16.1364 16.0815C16.1333 16.0056 16.1139 15.9312 16.0796 15.8634C16.0453 15.7956 15.9969 15.736 15.9375 15.6885L12.6969 12.4479C13.7253 11.2554 14.3153 9.74724 14.369 8.17347C14.4228 6.59971 13.9372 5.05482 12.9926 3.7949C12.048 2.53498 10.7012 1.63568 9.17549 1.24609C7.64977 0.856494 6.03671 0.999994 4.60372 1.6528C3.17073 2.30561 2.00385 3.42852 1.29652 4.8354C0.589181 6.24228 0.383868 7.84864 0.71461 9.38819C1.04535 10.9278 1.89228 12.3081 3.11502 13.3003C4.33775 14.2925 5.86286 14.8371 7.43753 14.8438ZM7.43753 2.09381C8.59331 2.09381 9.72314 2.43654 10.6841 3.07866C11.6451 3.72078 12.3942 4.63345 12.8365 5.70126C13.2788 6.76906 13.3945 7.94405 13.169 9.07763C12.9435 10.2112 12.3869 11.2525 11.5697 12.0697C10.7524 12.887 9.71117 13.4435 8.57759 13.669C7.44401 13.8945 6.26903 13.7788 5.20122 13.3365C4.13342 12.8942 3.22075 12.1452 2.57863 11.1842C1.93651 10.2232 1.59378 9.09335 1.59378 7.93757C1.59378 6.38771 2.20946 4.90133 3.30537 3.80541C4.40129 2.70949 5.88767 2.09381 7.43753 2.09381Z" fill="white"/>
                  </svg>
                }
                id="basic-nav-dropdown"
                className="search order-last order-xl-first"
                onClick={() => {setSearchOpen(true)}}
                ref={wrapperRef}
              >
                <Container fluid="xl" className="search-bar px-4 px-xl-0">
                <Row className="justify-content-lg-center">
                  <Col
                    xs={12}
                    className="py-xl-5 py-4 text-lg-center"
                  >
                    <Search indices={searchIndices} />
                  </Col>
                </Row>
              </Container>
            </NavDropdown>
            <Nav.Link
              href="https://login.meridianuniversity.edu"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline me-xl-2 d-none d-xl-flex"
            >
              Login
            </Nav.Link>
            <Nav.Link
              href="/admissions/graduate-admissions/apply-online"
              className="btn btn-primary ms-xl-2 me-xl-0 me-md-2 d-none d-md-flex"
            >
              Apply
            </Nav.Link>
            <Nav.Link
              href="https://login.meridianuniversity.edu"
              target="_blank"
              rel="noreferrer"
              className="ms-md-2 ms-xl-0 nav-icon d-xl-none"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.7084 20.1667C19.7084 18.575 19.0761 17.0485 17.9506 15.9231C16.8252 14.7976 15.2987 14.1653 13.707 14.1653H8.29317C7.50505 14.1653 6.72465 14.3205 5.99652 14.6221C5.2684 14.9237 4.60681 15.3658 4.04952 15.9231C2.92404 17.0485 2.29175 18.575 2.29175 20.1667V20.1667"
                  stroke="white"
                  strokeWidth="1.2"
                />
                <path
                  d="M10.9999 11.2288C13.4047 11.2288 15.3541 9.27941 15.3541 6.87467C15.3541 4.46993 13.4047 2.52051 10.9999 2.52051C8.59518 2.52051 6.64575 4.46993 6.64575 6.87467C6.64575 9.27941 8.59518 11.2288 10.9999 11.2288Z"
                  stroke="white"
                  strokeWidth="1.2"
                />
              </svg>
            </Nav.Link>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};

export default Navigation;
